export var DistributionType;
(function (DistributionType) {
    DistributionType["BUY"] = "BUY";
    DistributionType["RENT"] = "RENT";
    DistributionType["BUY_RENT"] = "BUY_RENT";
    DistributionType["BUY_AUCTION"] = "BUY_AUCTION";
    DistributionType["COMPULSORY_AUCTION"] = "COMPULSORY_AUCTION";
})(DistributionType || (DistributionType = {}));
export var PropertyType;
(function (PropertyType) {
    PropertyType["HOUSE"] = "HOUSE";
    PropertyType["APARTMENT"] = "APARTMENT";
    PropertyType["PLOT"] = "PLOT";
    PropertyType["OFFICE"] = "OFFICE";
    PropertyType["TRADING"] = "TRADING";
    PropertyType["GASTRONOMY_HOTEL"] = "GASTRONOMY_HOTEL";
    PropertyType["STORAGE_PRODUCTION"] = "STORAGE_PRODUCTION";
    PropertyType["AGRICULTURE_FORESTRY"] = "AGRICULTURE_FORESTRY";
    PropertyType["PARKING"] = "PARKING";
    PropertyType["SENIOR"] = "SENIOR";
    PropertyType["PROJECT"] = "PROJECT";
    PropertyType["MISCELLANEOUS"] = "MISCELLANEOUS";
    PropertyType["BUILDING"] = "BUILDING";
})(PropertyType || (PropertyType = {}));
